import React, { useState, useRef, useEffect, useCallback } from "react"
import currentExpensesJson from "../../../Configs/JSON/currentExpenses.json"
import "../../../styles/Calculator/CurrentExpenses.less"
import AccurateResult from "./AccurateResult"
import CalculatorStore from "../../../Configs/Store/calculator"
import CalculatorButton from "../../Common/CalculatorButton"
import closeImg from "../../../assets/Calculator/close.svg"
import { observer } from "mobx-react"
import { DataLayerFn } from "../../../Configs/API"
import { addCommas } from "../../Common/CommonFunctions"

const DEBOUNCE_DELAY = 250

const expensesKeypress = (event) => CalculatorStore.setCurrentChar(event.key)

const AmountInput = observer(function AmountInput({ onCommit }) {
  const debounceTimer = useRef(null)
  const editing = useRef(false)
  const storeValue = CalculatorStore.multipleAmt
  const [displayValue, setDisplayValue] = useState(storeValue)

  useEffect(() => {
    if (!editing.current) {
      setDisplayValue(storeValue)
    }
  }, [storeValue])

  useEffect(() => {
    return () => {
      if (debounceTimer.current !== null) {
        clearTimeout(debounceTimer.current)
      }
    }
  }, [])

  const handleAmountChange = (e) => {
    const digits = e.target.value.replace(/[^0-9]/g, "").replace(/^0+(?=\d)/, "")
    setDisplayValue(digits)
    if (typeof onCommit !== "function") {
      return
    }
    if (debounceTimer.current !== null) {
      clearTimeout(debounceTimer.current)
    }
    debounceTimer.current = setTimeout(() => {
      debounceTimer.current = null
      onCommit({ target: { value: digits } })
    }, DEBOUNCE_DELAY)
  }

  const handleFocus = () => {
    editing.current = true
  }

  const handleAmountBlur = () => {
    editing.current = false
    if (debounceTimer.current !== null) {
      clearTimeout(debounceTimer.current)
      debounceTimer.current = null
    }
    let valsCurrent
    if (typeof onCommit === "function") {
      valsCurrent = onCommit({ target: { value: displayValue } })
    }
    setDisplayValue(addCommas(valsCurrent === undefined || valsCurrent === null ? displayValue : valsCurrent))
  }

  return (
    <div className="custom-input-group custom-input-group-lg input-group">
      <div className="input-group-prepend">
        {" "}
        <span className="input-group-text">₹</span> {" "}
      </div>
      <input
        className="form-control"
        type="tel"
        pattern="[0-9]*"
        name="currentExpenses"
        id="currentExpenses"
        value={displayValue}
        onChange={handleAmountChange}
        onBlur={handleAmountBlur}
        onFocus={handleFocus}
        onKeyPress={expensesKeypress}
      />
    </div>
  )
})

const AmountFeedback = observer(function AmountFeedback() {
  if (!CalculatorStore.errorAmount) {
    return <div className="error">{CalculatorStore.errorAmountMessage}</div>
  }
  return <div className="inwords">{CalculatorStore.numToWords}</div>
})

const PopupNextButtons = observer(function PopupNextButtons({ onNext }) {
  const disabled = CalculatorStore.isDisabled
  if (!CalculatorStore.fifthScreenFlag) {
    return <CalculatorButton className="popupBtn col-12" title={"Next"} onClick={onNext} scrn={"Scr5"} disabled={disabled} />
  }
  return <CalculatorButton className="popupBtn col-12" title={"Next"} onClick={onNext} scrn={"Scr6"} disabled={disabled} />
})

const AccuratePopup = observer(function AccuratePopup({ scrn, onNext, onAccurate, onClose }) {
  return (
    <div className="currentExpensesPopup mt-1" nextscrbutton={scrn} showData={CalculatorStore.showData}>
      <div className="currentExp-wrap">
        <button type="button" className="close" onClick={onClose}>
          {" "}
          <img src={closeImg} alt={"close"} /> {" "}
        </button>
        <div className="form-row">
          <AccurateResult handlecurrentExpenses_Accurate={onAccurate} scrn={scrn} />
        </div>
        <div className="form-row">
          <PopupNextButtons onNext={onNext} />
        </div>
        {CalculatorStore.fifthScreenFlag === true && (
          <div className="footer">
            <span className="footerText">Don’t include savings earmarked for other goals such as child education, marriage etc.</span>
          </div>
        )}
      </div>
    </div>
  )
})

const CurrentExpenses = React.memo((props) => {
  const closeBtn = useCallback(() => {
    CalculatorStore.setShowData(0)
  }, [])

  const HandleChange = () => {
    if (CalculatorStore.showData === 0) {
      CalculatorStore.setShowData(1)
    } else {
      CalculatorStore.setShowData(0)
    }

    CalculatorStore.screenNo === "Scr5" && CalculatorStore.setFifthScreenFlag(true)
    try {
      DataLayerFn("AdditionalExpenses_Clicked", CalculatorStore, "Enter details for more accurate results")
    } catch {}
  }

  return (
    <div className="currentExpensesParentCont" nextscrbutton={props.scrn}>
      <div className="ttl">{currentExpensesJson[props.id].calculatorHeading}</div>
      <div className="current-expenses-container">
        <div className="row">
          <div className="col-12">
            <AmountInput onCommit={props.handlecurrentExpenses} />
          </div>
        </div>
      </div>

      <div className="expanding-colm">
        <div className="row">
          <div className="col-md-6 col d-sm-block">
            <AmountFeedback />
          </div>
          <div className="col-md-6 col-12 pl-sm-0 d-sm-block">
            <div className="currentExpensesLink" onClick={HandleChange}>
              {currentExpensesJson[props.id].calculatorLink}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <AccuratePopup
              scrn={props.scrn}
              onNext={props.handlenextbutton}
              onAccurate={props.handlecurrentExpenses_Accurate}
              onClose={closeBtn}
            />
          </div>
        </div>
      </div>
    </div>
  )
})

export default CurrentExpenses
